import { Divider } from "@blueprintjs/core";
import { CONTEXT_MENU } from "@blueprintjs/core/lib/esm/common/classes";
import { FormikProps } from "formik";
import { FGCustomInput, FGListen, FGSelectInput, FGTextInput, useApiEffect } from "nsitools-react";
import * as React from "react";
import PhoneInput from "react-phone-input-2";
import * as Yup from "yup";

import { CountryApi, EPlatform, PersonApi, PersonDto } from "../../../../api";
import { FGCountrySelect, SmallFormGenerator } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useSaveApi, useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";

export interface IAddPersonPanelProps {
  personEmail: string;
  newEmail: (newEmail: string) => void;
}

export const AddPersonPanel: React.FunctionComponent<IAddPersonPanelProps> = ({ personEmail, newEmail }) => {
  const formikRef = React.useRef<FormikProps<any>>();
  const api = useApiService(PersonApi);
  const countryApi = useApiService(CountryApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const [postalCode, setPostalCode] = React.useState("");
  const [isBelgium, setIsBelgium] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState(null);

  const [baseCountryId, baseCountryLoading] = useApiEffect(async () => await countryApi.getBelgianId(), []);
  const [languages, lloading] = useReferential((a) => a.getLanguages(), true, []);
  const [postalCodes, pcloading] = useReferential((a) => a.getStringifiedBelgianPostalCodes(), true, []);
  const [localities, locloading] = useReferential(
    (a) => a.getStringifiedBelgianLocalityFromPostalCode(postalCode ?? ""),
    false,
    [postalCode]
  );
  const [personSalutations, ploading] = useReferential(
    (a) => a.getPersonSalutations(currentLanguage.languageId),
    true,
    [currentLanguage.languageId]
  );
  const save = React.useCallback(
    (d: any) => {
      if (!!d.phoneNumber) {
        d.phoneNumber = "+" + d.phoneNumber;
      }
      if (!!d.mobilePhoneNumber) {
        d.mobilePhoneNumber = "+" + d.mobilePhoneNumber;
      }

      console.log("finalPhone", d.phoneNumber);
      console.log("finalmobilePhone", d.mobilePhoneNumber);
      return api.save(EPlatform.PORTAL, d);
    },
    [api]
  );
  const { saving, saveItem } = useSaveApi(
    React.useMemo(
      () => ({
        saveApiFn: save,
        onSaveFn: () => newEmail(email),
      }),
      [email, newEmail, save]
    )
  );

  const initialData = React.useMemo(
    () => new PersonDto({ countryId: baseCountryId, email: personEmail }).toJSON(),
    [baseCountryId, personEmail]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      firstName: Yup.string().nullable().required(t(ETLCodes.Required)),
      lastName: Yup.string().nullable().required(t(ETLCodes.Required)),
      languageId: Yup.number().nullable().required(t(ETLCodes.Required)),
      personHonorificId: Yup.string().nullable().required(t(ETLCodes.Required)), //number().required(),
      street: Yup.string().nullable().required(t(ETLCodes.Required)),
      number: Yup.string().nullable().required(t(ETLCodes.Required)),
      postalCode: Yup.string().nullable().required(t(ETLCodes.Required)),
      countryId: Yup.number()
        .nullable()
        .required(t(ETLCodes.Required))
        .test("is-vat-be", t(ETLCodes.VATNotCorrespondingToCountry), async function (value) {
          if (!this.parent.vatNumber) return true;
          const belgium = await countryApi.isBelgian(value);
          return !belgium.value || (belgium.value && this.parent.vatNumber.substr(0, 2) === "BE");
        }),
      city: Yup.string().nullable().required(t(ETLCodes.Required)),
      email: Yup.string()
        .nullable()
        .test("required", t(ETLCodes.Required), async function (value) {
          if (
            (this.parent.phoneNumber === undefined || this.parent.phoneNumber === null) &&
            (this.parent.mobilePhoneNumber === undefined || this.parent.mobilePhoneNumber === null)
          ) {
            return value !== null && value !== undefined;
          }
          return true;
        }),
      phoneNumber: Yup.string()
        .nullable()
        .test("required", t(ETLCodes.Required), async function (value) {
          if (
            (this.parent.email === undefined || this.parent.email === null) &&
            (this.parent.mobilePhoneNumber === undefined || this.parent.mobilePhoneNumber === null)
          ) {
            return value !== null && value !== undefined;
          }
          return true;
        }),
      mobilePhoneNumber: Yup.string()
        .nullable()
        .test("required", t(ETLCodes.Required), async function (value) {
          if (
            (this.parent.phoneNumber === undefined || this.parent.phoneNumber === null) &&
            (this.parent.email === undefined || this.parent.email === null)
          ) {
            return value !== null && value !== undefined;
          }
          return true;
        }),
    });
  }, [countryApi, t]);

  const [selectedcountryIsoCode, setSelectedcountryIsoCode] = React.useState<string>("be");
  const [currentcountryIsoCode, setcurrentcountryIsoCode] = React.useState<string>("be");

  React.useEffect(() => {
    //compute iso code
    console.log("phoneTouched", formikRef.current?.touched.phoneNumber);
    console.log("modbileTouched", formikRef.current?.touched.mobilePhoneNumber);
    if (
      selectedcountryIsoCode === currentcountryIsoCode ||
      !!formikRef.current?.touched.phoneNumber ||
      !!formikRef.current?.touched.mobilePhoneNumber
    ) {
      return;
    }
    setcurrentcountryIsoCode(selectedcountryIsoCode);
  }, [currentcountryIsoCode, selectedcountryIsoCode]);

  return (
    !baseCountryLoading && (
      <SmallFormGenerator
        initialValues={initialData}
        onSubmit={saveItem}
        editMode={true}
        saving={saving}
        validationSchema={FormSchema}
        formikInnerRef={(f) => (formikRef.current = f)}
      >
        <FGListen
          field="countryId"
          onChanged={(value, f) => {
            if (value === null) {
              f.setFieldValue("countryId", baseCountryId);
              setIsBelgium(true);
            } else {
              if (value === baseCountryId) {
                setIsBelgium(true);
              } else {
                setIsBelgium(false);
              }
            }
          }}
        />
        <FGListen
          field="countryId"
          onChanged={async (value) => setSelectedcountryIsoCode((await countryApi.get(value)).isoCode.toLowerCase())}
        />
        <FGListen
          field="postalCode"
          onChanged={(value) => {
            if (isBelgium) {
              setPostalCode(value);
            }
          }}
        />
        <FGListen
          field="email"
          onChanged={(value) => {
            setEmail(value);
          }}
        />
        <FGSelectInput
          name="personHonorificId"
          items={personSalutations}
          loading={ploading}
          label={t(ETLCodes.Salutation)}
        />
        <FGTextInput name="lastName" label={t(ETLCodes.LastName)} />
        <FGTextInput name="firstName" label={t(ETLCodes.FirstName)} />
        <FGTextInput name="email" label={t(ETLCodes.Email)} requiredMark />
        <FGCountrySelect name="countryId" label={t(ETLCodes.Country)} />
        <FGCustomInput name="phoneNumber" label={t(ETLCodes.PhoneNumber)} requiredMark>
          {(ctx) => (
            <PhoneInput
              placeholder=""
              country={currentcountryIsoCode}
              value={ctx.formik.values.phoneNumber}
              onChange={(value) => {
                ctx.formik.setFieldValue("phoneNumber", value);
                ctx.formik.setTouched({ ...formikRef.current.touched, phoneNumber: true }, false);
              }}
              inputStyle={{ width: "100%" }}
              enableSearch
              searchPlaceholder=""
            />
          )}
        </FGCustomInput>
        <FGCustomInput name="mobilePhoneNumber" label={t(ETLCodes.MobilePhoneNumber)} requiredMark>
          {(ctx) => (
            <PhoneInput
              placeholder=""
              country={currentcountryIsoCode}
              value={ctx.formik.values.mobilePhoneNumber}
              onChange={(value) => {
                ctx.formik.setFieldValue("mobilePhoneNumber", value);
                ctx.formik.setTouched({ ...formikRef.current.touched, mobilePhoneNumber: true }, false);
              }}
              inputStyle={{ width: "100%" }}
              enableSearch
              searchPlaceholder=""
            />
          )}
        </FGCustomInput>
        <FGSelectInput
          name="languageId"
          items={languages}
          loading={lloading}
          label={t(ETLCodes.Language)}
          requiredMark
        />
        <Divider />
        <FGTextInput name="street" label={t(ETLCodes.Street)} />
        <FGTextInput name="number" label={t(ETLCodes.StreetNumber)} />
        {isBelgium ? (
          <FGSelectInput name="postalCode" items={postalCodes} loading={pcloading} label={t(ETLCodes.PostalCode)} />
        ) : (
          <FGTextInput name="postalCode" label={t(ETLCodes.PostalCode)} />
        )}
        {isBelgium ? (
          <FGSelectInput name="city" items={localities} loading={locloading} label={t(ETLCodes.City)} />
        ) : (
          <FGTextInput name="city" label={t(ETLCodes.City)} />
        )}
      </SmallFormGenerator>
    )
  );
};
